import { useState, useRef, FC } from 'react';
import { ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList, ButtonProps, ListItemIcon, ListItemText } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button } from "@gisce/oficina-virtual-components";

interface CustomButtonGroupProps extends ButtonProps {
  // Must do this because MenuItem onClick event and Button onClick event are 
  // not directly compatible
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

interface ContractButtonGroupProps {
  options: CustomButtonGroupProps[]
}

const ContractButtonGroup: FC<ContractButtonGroupProps> = ({options}) => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleClose = (event: Event) => {
    if (
      anchorRef.current && 
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      {options.length <= 2 && options.map(option => 
        <Button 
          sx={{
            marginLeft: '5px',
            marginRight: '5px', 
            overflow: 'hidden'
          }}
          variant={'contained'}
          color={'primary'}
          {...option} 
          key={option.key}
        />
      )}
      {options.length > 2 && <ButtonGroup
        variant='contained'
        ref={anchorRef}
        aria-label='Button group with a nested menu'
        // disabled={downloadStatus}
      >
        <Button
          variant={'contained'}
          color={'primary'}
          {...options[0]} 
          key={options[0].key}
        />
        <Button
          size='small'
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label='select download option'
          aria-haspopup='menu'
          onClick={() => setOpen((prevOpen) => !prevOpen)}
          color='primary'
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>}
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id='split-button-menu' autoFocusItem>
                  {options.slice(1).map(option => (
                    <MenuItem
                      key={option.key}
                      onClick={(event) => option?.onClick && option.onClick(event)}
                    >
                        <ListItemIcon>
                          {option.startIcon}
                        </ListItemIcon>
                        <ListItemText>
                          {option.children}
                        </ListItemText>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default ContractButtonGroup;